<template>
    <div>    
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4 text-truncate">Add New Charge {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate">View Charge - {{this.inputName}}</h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">Edit Charge - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>
        <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory">
                <b><label>Created By: </label></b>
                {{inputCreatedBy || "System" }} | {{inputCreatedAt | dateFilter}} 
                <br>
                <b><label>Updated By:</label></b>
                {{inputUpdatedBy || "System" }} | {{inputUpdatedAt | dateFilter}} 
            </b-tab>
        </b-tabs>
        
            <form id="form-proper">
                <a-spin :spinning="spinning">
                <div v-if="customFormMode == 1" v-show="showDetails">
                    <base-input alternative="" label="Code" placeholder="" v-model="inputCode" input-classes="form-control" />
                    <base-input alternative="" label="Name" placeholder="" v-model="inputName" input-classes="form-control" required/>
                    <base-input alternative="" label="GL Code" placeholder="" v-model="inputGlCode" input-classes="form-control"/>
                    <base-input alternative="" label="Remark">
                        <textarea rows="4" class="form-control" v-model="inputRemark"/>
                    </base-input>
                </div>
                <div v-if="customFormMode == 2">
                    <!-- Override -->
                    <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="Charge" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
                </div>
                <div v-if="customFormMode == 3">
                    <!-- Append -->
                    <a-tabs defaultActiveKey="1">
                        <a-tab-pane tab="Basic" key="1">
                            <base-input alternative="" label="Code" placeholder="" v-model="inputCode" input-classes="form-control" />
                            <base-input alternative="" label="Name" placeholder="" v-model="inputName" input-classes="form-control" required/>
                            <base-input alternative="" label="GL Code" placeholder="" v-model="inputGlCode" input-classes="form-control" required/>
                            <base-input alternative="" label="Remark">
                                <textarea rows="4" class="form-control" v-model="inputRemark"/>
                            </base-input>
                        </a-tab-pane>
                        <a-tab-pane tab="Custom Fields" key="2" forceRender>
                            <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="Charge" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                        </a-tab-pane>
                    </a-tabs>
                </div>
            </a-spin>
                <div v-if="this.$attrs.viewMode != true">
                    <div v-if="serverType == 'ho'" style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                        <button v-if="(profileId == 0)" :disabled="buttonDisabled" type="button" class="btn btn-primary float-right" @click.prevent="create">Add</button>
                        <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                    </div> 
                    <div v-else style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                        <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button>
                    </div> 
                </div>
            
            </form>
    </div>
</template>


<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import ValidateField from '../../components/validateFormUtils.js'
import DynamicForm from '../DynamicForm.vue'
import { mapState } from 'vuex'
import moment from 'moment'
var component_x;  
export default {
    components: {
        DynamicForm
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType']),
    },
    mounted: async function() {
        this.spinning = true;
        this.buttonDisabled = true;
        var document_types = await HTTPRequest.getRequest(this.endPoint + 'document_types/get_valid_document_types', null)
        this.documentTypeOptions = document_types
        // Meta-data Call
        const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Charge?field_name=name'  , null)
        const sytemModuleId = sytemModule.id
        const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)
        if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
            const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
            if(accSystemModule != null){
                if(accSystemModule.form_mode != undefined){
                    this.customFormMode = accSystemModule.form_mode
                }
                if(accSystemModule.customized_forms != undefined){
                    this.customForm = accSystemModule.customized_forms
                }
            }
        }
        if(this.serverType == 'branch'){
            var form = document.getElementById("form-proper")
            var elements = form.elements;
            for (var i = 0, len = elements.length; i < len; ++i) {
                elements[i].disabled = true;
            }
        } else {
            if(this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].disabled = true;
                }
            }
        } 
        component_x = this
        if( component_x.profileId > 0){
            var data = await HTTPRequest.getRequest(component_x.endPoint + 'charges/' + component_x.profileId, null)    
            if(data == undefined){
                component_x.$router.go()
            } else {
                if(data["error"] == undefined){
                    component_x.inputCode = data["code"]
                    component_x.inputName = data["name"]
                    component_x.inputRemark = data["remark"]
                    component_x.inputGlCode = data["gl_code"]
                    component_x.inputCreatedBy = data["created_by"]
                    component_x.inputCreatedAt = data["created_at"]
                    component_x.inputUpdatedBy = data["updated_by"]
                    component_x.inputUpdatedAt = data["updated_at"]
                } else {
                    this.errors = data["error"].split(",") //format will change when error message has comma
                    //component_x.$router.push("/")
                } 
            } 
        } 
        this.dynamicFormKey++;
        this.spinning = false;
        this.buttonDisabled = false;
    },
    data: function(){
        return {
            spinning: false,
            buttonDisabled: false,
            charge: null,
            inputCode: '',
            inputName: '',
            inputRemark: '',
            inputGlCode: '',
            errors: [],
            documentTypeOptions: [],
            showDetails: true,
            inputCreatedBy: '',
            inputCreatedAt: '',
            inputUpdatedBy: '',
            inputUpdatedAt: '',

            // FOR META-DATA
            customFormMode: 1,
            customForm: {},
            profileData: {},
            dynamicFormKey: 0,
            supplier: {},
            formErrors: [],
            defaultChargeDetails:{}
        }
    },
    filters: {
        dateFilter: function (timestamp) {
            return moment(timestamp).format('L LTS')
        }
    },
    methods: {
        updateSettings(newFormSettings, settingsGrouping, errors){
            var formSettingsCopy = this.charge
            var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
            this.formErrors = errors

            if(this.customFormMode == 3) {
                this.errors = errors
            }

            this.charge = mergedHash
        },
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        openDetails() {
            this.showDetails = true
        },
        openHistory() {
            this.showDetails = false
        },
        validateForm(){
            this.errors = [];
            this.errors.push(ValidateField.required('Name', this.inputName));
            //this.errors.push(ValidateField.required('GL Code', this.inputGlCode));
            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        create: async function() {
            if(!this.validateForm()) {
                this.buttonDisabled = true;
                this.spinning = true;
                var ChargePayload = {
                    charge: {
                        name: this.inputName.trim(),
                        code: this.inputCode.trim(), 
                        remark: this.inputRemark,
                        gl_code: this.inputGlCode.trim(), 
                        status: 'A'
                    }
                }
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'charges', null, ChargePayload)    
                if(post_request == undefined){
                    this.$emit('refreshPage', event)
                } else {
                    if(post_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = post_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
                this.spinning = false;
                this.buttonDisabled = false;
            }
        },
        update: async function(){
            if(!this.validateForm()) {
                this.spinning = true;
                this.buttonDisabled = true;
                var ChargePayload = {
                        charge: {
                            name: this.inputName.trim(), 
                            code: this.inputCode.trim(), 
                            remark: this.inputRemark,
                            gl_code: this.inputGlCode.trim(), 
                            document_type_id: this.inputDocumentType
                        }
                    }
                // status: 'A'
                var put_request = await HTTPRequest.putRequest(this.endPoint + 'charges/' + this.profileId, null, ChargePayload) 
                if(put_request == undefined){
                    this.$emit('refreshPage', event)
                } else {
                    if(put_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = put_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
                this.spinning = false;
                this.buttonDisabled = false;
            }
        },
    }
}
</script>

<style>
</style>
